import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { SkeletonBase } from './SkeletonBase';
export var CategoriesSkeleton = function () {
    var elements = Array.from({ length: 16 }, function (_, index) { return (_jsx("div", { className: "Skeleton-Container", children: _jsx(SkeletonBase, { height: 175 }) }, index)); });
    return _jsx(_Fragment, { children: elements });
};
